import MySearchesTableHeader from './MySearchesTableHeader'
export default MySearchesTableHeader
